// extracted by mini-css-extract-plugin
export var paginationContainer = "_1u-0";